import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  columns: [
    {
      label: 'Profession', field: 'prfs_name'
    },
    {
      label: 'Job Category', field: 'job_ctgr_name'
    },
    {
      label: 'Fee', field: 'fee'
    },
    {
      label: 'Percentation', field: 'percentation'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/profession-fee/status/AC'}
    useIPA.get(param).then(response => {
      const professionfee = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...professionfee})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/profession-fee/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = []
      const rawDataChild = []
      const rawDataChildF = []
      var p = 0
      for (var i = 0, l = formData.fee.length; i < l; i++) {
        if (formData.prfs_id[i]) {
          rawDataChild[p] = {
            prfs_id: parseInt(formData.prfs_id[i]),
            fee: parseInt(formData.fee[i]),
            job_category_id: parseInt(formData.job_category_id[i]),
            percentation: parseInt(formData.percentation[i])
          }
          p++
        }
      }
      const result = rawDataChild.reduce(function (r, a) {
        r[a.job_category_id] = r[a.job_category_id] || []
        r[a.job_category_id].push(a)
        return r
      }, Object.create(null))
      var b = 0
      for (var a = 0, s = formData.job_category_id_head.length; a < s; a++) {
        if (formData.job_category_id_head[a]) {
          b++
          for (var bs = 0, sb = result[b].length; bs < sb; bs++) {
            delete result[b][bs].job_category_id
          }
          rawDataChildF[a] = {
            job_category_id: parseInt(formData.job_category_id_head[a]),
            profession: result[b]
          }
        } 
      }
      rawData.push({
        profession_fee : rawDataChildF
      })
      const param = { rawData: rawData[0], url: 'dashboard/master/profession-fee', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(rawDataChild)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/profession-fee', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, professionfee) {
    state.all = professionfee.rows
    state.pages = professionfee.pages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
